import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/observable';
@Injectable({
  providedIn: 'root'
})
export class MyserviceService {

  constructor(private http:HttpClient) {

  }
  baseUrl="https://isuweb.herokuapp.com/cust/";
  httpHeaders= new HttpHeaders({'Content-Type':'application/json'})

  users():Observable<any>{
    console.log("In login service ");
    return this.http.get(this.baseUrl,
    {headers:this.httpHeaders});
  }
  ba="https://isuweb.herokuapp.com/feedback/";

    feedbacks():Observable<any>{
      console.log("In login service ");
      return this.http.get(this.ba,
      {headers:this.httpHeaders});
    }

  userSignUp(b):Observable<any>{
    const body={name:b.name,age:b.age,email:b.email,gender:b.gen,username:b.username,password:b.password}
    console.log("In service "+body.name);
    return this.http.post(this.baseUrl,body,
    {headers:this.httpHeaders});
  }
  base="https://isuweb.herokuapp.com/login/"

    user:any;
    userUpdate(b):Observable<any>{
      const body={name:b.name,age:b.age,email:b.email,gender:b.gen,username:b.username,password:b.password}
      console.log("In service "+body.name);
      this.user=JSON.parse(localStorage.getItem('loginUser'));
      return this.http.put(this.base+this.user.username,body,
      {headers:this.httpHeaders});
    }


  del(b):Observable<any>{
    console.log("In login service "+b)
    return this.http.delete(this.base+b,
    {headers:this.httpHeaders});
  }

  userLogin(b):Observable<any>{
    console.log("In login service "+b)
    return this.http.get(this.base+b,
    {headers:this.httpHeaders});
  }
}
